module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1217.51032fae.jpg";